import React from 'react';
import { ADVANCED_CHART_TYPES } from '../../constants/chartsConstants';
import DemographicsReport from './demographicsReport';
import ParticipantsOvertimeReport from './participantsOvertimeCharts';
import CategoryComparision from './categoryComparision';
import GenderComparisionReport from './genderComparisionReport';
import AgeGroupAnswerReport from './ageGroupAnswerReport';
import GenderAnswersReport from './genderAnswersReport';
import AgeGroupComparisionReport from './ageGroupComparisionReport';

const ChartDisplay = ({ activeChart, questionId, dateRange }) => {
  const { startDate, endDate } = dateRange || {};

  if (activeChart === ADVANCED_CHART_TYPES.DEMOGRAPHICS) {
    return (
      <DemographicsReport
        questionId={questionId}
        startDate={startDate}
        endDate={endDate}
      />
    );
  }

  if (activeChart === ADVANCED_CHART_TYPES.PARTICIPANTS_OVERTIME) {
    return (
      <ParticipantsOvertimeReport
        questionId={questionId}
        startDate={startDate}
        endDate={endDate}
      />
    );
  }

  if (activeChart === ADVANCED_CHART_TYPES.CATEGORY_COMPARISION) {
    return (
      <CategoryComparision
        questionId={questionId}
        startDate={startDate}
        endDate={endDate}
      />
    );
  }

  if (activeChart === ADVANCED_CHART_TYPES.GENDER_COMPARISION) {
    return (
      <GenderComparisionReport
        questionId={questionId}
        startDate={startDate}
        endDate={endDate}
      />
    );
  }

  if (activeChart === ADVANCED_CHART_TYPES.AGE_GROUP_COMPARISION) {
    return (
      <AgeGroupComparisionReport
        questionId={questionId}
        startDate={startDate}
        endDate={endDate}
      />
    );
  }

  if (activeChart === ADVANCED_CHART_TYPES.AGE_GROUP_ANSWERS) {
    return (
      <AgeGroupAnswerReport
        questionId={questionId}
        startDate={startDate}
        endDate={endDate}
      />
    );
  }

  if (activeChart === ADVANCED_CHART_TYPES.GENDER_ANSWERS) {
    return (
      <GenderAnswersReport
        questionId={questionId}
        startDate={startDate}
        endDate={endDate}
      />
    );
  }

  return null;
};

export default ChartDisplay;



// WEBPACK FOOTER //
// ./src/components/advancedReport/chartDisplay.js